import React, { useDispatch, useEffect, useGlobal } from "reactn";

export const useFavorites = () => {
	const [favorites] = useGlobal("favorites");
	const [offices] = useGlobal("offices");
	const requestFavorites = useDispatch("getFavorites");

	const favs = Object.values(offices).filter((of) =>
		favorites.offices.some((oid) => oid === of.id)
	);

	useEffect(() => {
		if (favorites.offices.length === 0) requestFavorites();
	}, []);

	const { isLoading, error } = favorites;

	return [favs, isLoading || Object.keys(offices).length === 0, error];
};
